import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../models/auth.models';

@Injectable({ providedIn: 'root' })

export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(email: string, password: string) {
        // return this.http.post<any>(`/users/authenticate`, { email, password })
        return this.http.post<any>(`/auth/customer/login-password`, { email, password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user && user.access_token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }

    sendOtp(email: string) {
        console.log("Sending OTP to email:", email);
        return this.http.post<any>(`/auth/send-otp`, { email });
    }

    verifyOtp(email: string, otp: string) {
        return this.http.post<any>(`/auth/customer/login-otp`, { email, otp })
            .pipe(map(user => {
                if (user && user.access_token) {
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }
                return user;
            }));
    }

    register(userData: any) {
        return this.http.post<any>(`/auth/register`, userData);
        // .pipe(map(user => {
        //     if (user && user.access_token) {
        //         sessionStorage.setItem('currentUser', JSON.stringify(user));
        //         this.currentUserSubject.next(user);
        //     }
        //     return user;
        // }));
    }

    verifyRegistration(email: string, otp: string) {
        return this.http.post<any>(`/auth/verify-otp`, { email, otp })
    }

    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }

    getEnv() {
        return this.http.get<any>(`/esign/user-mode`)
    }

    switchEnv(mode: string) {
        return this.http.post<string>(`/esign/user-mode`, { mode }).pipe(
            map((res: string) => {
                // sessionStorage.setItem('env', res);
                window.location.reload();
                return res;
            })
        );
    }

}
